var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrilles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(7.5 7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M3.5,7 C1.6,7 0,5.4 0,3.5 C0,1.6 1.6,0 3.5,0 C5.4,0 7,1.6 7,3.5 C7,5.4 5.4,7 3.5,7 Z M3.5,1 C2.1,1 1,2.1 1,3.5 C1,4.9 2.1,6 3.5,6 C4.9,6 6,4.9 6,3.5 C6,2.1 4.9,1 3.5,1 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 12.5,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M3.5 25C1.6 25 0 23.4 0 21.5 0 19.6 1.6 18 3.5 18 5.4 18 7 19.6 7 21.5 7 23.4 5.4 25 3.5 25zM3.5 19C2.1 19 1 20.1 1 21.5 1 22.9 2.1 24 3.5 24 4.9 24 6 22.9 6 21.5 6 20.1 4.9 19 3.5 19zM12.5 7C10.6 7 9 5.4 9 3.5 9 1.6 10.6 0 12.5 0 14.4 0 16 1.6 16 3.5 16 5.4 14.4 7 12.5 7zM12.5 1C11.1 1 10 2.1 10 3.5 10 4.9 11.1 6 12.5 6 13.9 6 15 4.9 15 3.5 15 2.1 13.9 1 12.5 1zM12.5 16C10.6 16 9 14.4 9 12.5 9 10.6 10.6 9 12.5 9 14.4 9 16 10.6 16 12.5 16 14.4 14.4 16 12.5 16zM12.5 10C11.1 10 10 11.1 10 12.5 10 13.9 11.1 15 12.5 15 13.9 15 15 13.9 15 12.5 15 11.1 13.9 10 12.5 10z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 21.5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 3.5,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M21.5 16C19.6 16 18 14.4 18 12.5 18 10.6 19.6 9 21.5 9 23.4 9 25 10.6 25 12.5 25 14.4 23.4 16 21.5 16zM21.5 10C20.1 10 19 11.1 19 12.5 19 13.9 20.1 15 21.5 15 22.9 15 24 13.9 24 12.5 24 11.1 22.9 10 21.5 10zM21.5 25C19.6 25 18 23.4 18 21.5 18 19.6 19.6 18 21.5 18 23.4 18 25 19.6 25 21.5 25 23.4 23.4 25 21.5 25zM21.5 19C20.1 19 19 20.1 19 21.5 19 22.9 20.1 24 21.5 24 22.9 24 24 22.9 24 21.5 24 20.1 22.9 19 21.5 19z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrilles);
export default __webpack_public_path__ + "static/media/Grilles.b983163b175761c51074b1113469c84f.svg";
export { ForwardRef as ReactComponent };